import React, { useState } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import {
  Input,
  InputGroup,
  InputGroupText
} from '@appfolio/react-gears';

interface Props {
  password: string | null;
  setPassword: (password: string) => void;
  inputAriaLabel?: string;
}

const ShowPasswordInput = (props: Props) => {
  const {
    password,
    setPassword,
    inputAriaLabel
  } = props;

  const [hidePassword, setHidePassword] = useState(true);
  const [hover, setHover] = useState(false);

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setHidePassword(!hidePassword);
    }
  };

  return (
    <InputGroup className='mb-2'>
      <Input
        type={hidePassword ? 'password' : 'text'}
        maxLength={32}
        onChange={e => setPassword(e.target.value)}
        value={password ?? ''}
        aria-label={inputAriaLabel ?? 'Input your password'}
        data-testid='password-input'
      />
      <InputGroupText
        onClick={() => setHidePassword(!hidePassword)}
        onKeyDown={handleKeyDown}
        onMouseOver={() => setHover(true)}
        onFocus={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onBlur={() => setHover(false)}
        className={hover ? 'bg-light' : ''}
        tabIndex={0}
        aria-label={hidePassword ? 'show password' : 'hide password'}
      >
        {hidePassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
      </InputGroupText>
    </InputGroup>
  );
};

export default observer(ShowPasswordInput);
